import { DataBean } from "../DataBean";

export class LocationMaintenance extends DataBean {
  public async getLocationMaintenanceCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getLocationMaintenanceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteLocationMaintenance(
    idlocationmaintenance: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteLocationMaintenance_Number",
      [idlocationmaintenance]
    );
  }

  public async updateLocationMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.LocationMaintenance_updateLocationMaintenance_com.orange.finance.processcontract.bean.LocationMaintenance",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:
            "com.orange.finance.processcontract.bean.LocationMaintenance",
        },
      ]
    );
  }
}
